const nominees = {
  slug: 'nominees',
  submitNominee: () => `${nominees.slug}`
}

export default nominees
